"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FitssoExpress = void 0;
var ci_component_injector_service_1 = require("@src/services/ci-component-injector.service");
var cash_dom_1 = __importDefault(require("cash-dom"));
var generator_const_1 = require("@src/const/dom-crud/generator.const");
var google_const_1 = require("./const/google.const");
var x_const_1 = require("./const/x.const");
var FitssoExpress = /** @class */ (function () {
    function FitssoExpress() {
        this.settings = {
            url: 'https://auth.scaleyourgym.com',
            realm: 'dev-fittec-cloud',
            clientId: 'dev-fittec-cloud',
            socials: 'google,microsoft,apple,twitter,linkedin,paypal,instagram,facebook',
        };
        this.extensionCall = false;
    }
    FitssoExpress.prototype.loadModule = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                (0, ci_component_injector_service_1._UpdateCorporateIdentitySettings)({
                    keycloak: {
                        active: true,
                        config: {
                            url: 'https://auth.scaleyourgym.com',
                            realm: 'dev-fittec-cloud',
                            clientId: 'dev-fittec-cloud',
                        },
                    },
                });
                (0, ci_component_injector_service_1._InjectStencilWebComponents)();
                this.generateLogin();
                return [2 /*return*/];
            });
        });
    };
    FitssoExpress.prototype.generateLogin = function () {
        var _this = this;
        if (this.module.references.socials.domElement) {
            var ciLogin = (0, cash_dom_1.default)('<ci-login>')
                .attr('social-logins', 'true')
                .attr('form-logins', 'false')
                .attr('keycloak-identity-providers', this.settings.socials);
            ciLogin.on('change', function (event) {
                var _a, _b;
                console.log('login change', (_a = event === null || event === void 0 ? void 0 : event.detail) === null || _a === void 0 ? void 0 : _a.data);
                if (event.detail.data.keycloak) {
                    _this.keycloak = event.detail.data.keycloak;
                }
                if (((_b = _this.keycloak) === null || _b === void 0 ? void 0 : _b.token) && _this.extensionCall === false) {
                    _this.loginChange(_this.keycloak);
                }
            });
            this.module.references.socials.domElement.append(ciLogin);
            var ciLogout = (0, cash_dom_1.default)('<ci-logout>');
            this.module.references.socials.domElement.append(ciLogout);
        }
    };
    FitssoExpress.prototype.loginChange = function (keycloak) {
        return __awaiter(this, void 0, void 0, function () {
            var socialIdp;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.extensionCall = true;
                        socialIdp = localStorage.getItem('hacktrick-corpident-socialidp');
                        if (!(socialIdp === null || socialIdp === void 0 ? void 0 : socialIdp.length)) return [3 /*break*/, 5];
                        (0, generator_const_1._CreateLoadingScreen)();
                        console.log('login change', keycloak);
                        if (!(socialIdp === 'google')) return [3 /*break*/, 2];
                        return [4 /*yield*/, (0, google_const_1._ExtendGoogleSSOData)(this, keycloak)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        if (!(socialIdp === 'twitter')) return [3 /*break*/, 4];
                        return [4 /*yield*/, (0, x_const_1._ExtendXSSOData)(this, keycloak)];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4:
                        this.extensionCall = false;
                        (0, generator_const_1._DeleteLoadingScreen)();
                        _a.label = 5;
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    return FitssoExpress;
}());
exports.FitssoExpress = FitssoExpress;
